import { Menu, Stack, styled } from '@mui/material';

export const ChallengeListWrapper = styled(Stack)(({ theme }) => ({
  boxSizing: 'border-box',
  padding: 8,
  border: '2px solid transparent',
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.common.white,
  boxShadow: theme.customShadows.z1,
  cursor: 'pointer',

  '&:hover': {
    border: `2px solid ${theme.palette.primary.main}`,
    boxShadow: theme.customShadows.z8,
  },
}));

export const ChallengeClickArea = styled('div')(() => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'space-between',
}));

export const ChallengeItem = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  height: 40,
}));

export const ChallengeMenuWrapper = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    boxShadow: theme.customShadows.z20,
  },
}));
